<div class="dashboard-container flex flex-col min-h-screen w-full h-full">
    <app-title-section [title]="'Recherche Prestataire'"></app-title-section>
    <div class="dashboard-content h-full flex flex-col items-center mt-12">
            <p-autocomplete 
            [ngModel]="searchValue" 
            [suggestions]="filteredProviders"
            [minQueryLength]="1"
            [showClear]="true"
            placeholder="Recherchez email ou company..."
            [emptyMessage]="'Aucun prestataire ne correspond à votre recherche'"
            [autofocus]="true"
            (onSelect)="onSelectProvider($event)"
            (completeMethod)="onSearchProviders($event)"
            >
            <ng-template let-provider #item>
                <div class="flex items-center gap-3 p-1 w-full">
                    <!-- Infos principales -->
                    <div class="flex flex-col flex-1 gap-y-2">
                        <div class="flex items-center gap-2">
                            <span class="font-semibold">{{ provider.firstName }} {{ provider.lastName }}</span>
                            <!-- Badge vérifié conditionnel -->
                            @if (provider.isVerified) {
                                <p-chip class="verified-chip">
                                    <app-icon-svg 
                                        class="search-icon"
                                        width="16" 
                                        height="16" 
                                        iconName="success-chip" 
                                        color="#347A79"
                                    ></app-icon-svg>
                                    <span class="text-sm">Vérifié</span>
                                </p-chip>
                            } @else {
                                <p-chip class="not-verified-chip">
                                    <app-icon-svg 
                                        class="search-icon"
                                        width="16" 
                                        height="16" 
                                        iconName="error-chip" 
                                        color="#de8700"
                                    ></app-icon-svg>
                                    <span class="text-sm">Non Vérifié</span>
                                </p-chip>
                            }
                        </div>
                        <div class="flex items-center gap-x-4">
                            <div class="flex items-center gap-x-1">
                                <app-icon-svg 
                                    class="search-icon"
                                    width="12" 
                                    height="12" 
                                    iconName="user" 
                                    color="#57636c"
                                ></app-icon-svg>
                                <span class="text-sm">{{ provider.email }}</span>
                            </div>
                            <div class="flex items-center gap-x-1">
                                <app-icon-svg 
                                    class="search-icon"
                                    width="12" 
                                    height="12" 
                                    iconName="cgu-cgv"
                                    color="#57636c"
                                ></app-icon-svg>
                                <span class="text-sm">{{ provider.companyName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            </p-autocomplete>
            <div class="flex-1 flex flex-col items-center justify-center gap-y-8">
                <div class="rounded relative">
                    <app-icon-svg 
                        class="search-icon"
                        width="64" 
                        height="64" 
                        iconName="search" 
                        color="#57636c"
                    ></app-icon-svg>
                </div>
                <p class="description">Recherchez un prestataire par email ou nom d'entreprise</p>
            </div>
    </div>
</div>